export default [
    {
        path: "/home",
        name: "ff-home",
        component: () => import("@/views/home.vue"),
        props: true
    },
    {
        path: "/ai/gpt",
        name: "ai-gpt",
        component: () => import("@/views/ai/gpt.vue"),
    },
    {
        path: "/ai/chat",
        name: "ai-chat",
        component: () => import("@/views/ai/chat.vue"),
    },
    {
        path: "/ai/chatnew",
        name: "ai-chatnew",
        component: () => import("@/views/ai/chatnew.vue"),
    },
    {
        path: "/ai/chat/:sid",
        name: "ai-chat-sid",
        component: () => import("@/views/ai/chat.vue"),
    },
    {
        path: "/ai/image",
        name: "ai-image",
        component: () => import("@/views/ai/image.vue"),
    },
    {
        path: "/ai/video",
        name: "ai-video",
        component: () => import("@/views/ai/video.vue"),
    },
    {
        path: "/ai/whisk",
        name: "ai-whisk",
        component: () => import("@/views/ai/whisk.vue"),
    },
]